export default __webpack_public_path__ + "static/media/notifications-icon.adbcbeff.svg";